
import { Component, Vue } from "vue-property-decorator";
import navigationCirle from './components/navigationCirle.vue'
import detailsNavigation from './components/detailsNav.vue'
import {
    SickLeaveVisitSettingService, StudentDailyAttendanceSnapshotStatus
} from "@/api/service-proxies";
import Pagination from "@/components/Pagination/index.vue";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { UserModule } from "@/store/modules/user";
import moment from "moment";
class PageSearchRequest extends PagedRequestDto {
    tenantId!: number
    name!: string;
    attendanceSnapshotStatus!: number
}
@Component({
    name: "schoolAnalysis",
    components: {
        Pagination, navigationCirle, detailsNavigation
    },
})
export default class schoolAnalysis extends Vue {
    pageSizeArray = [10, 13, 20, 30, 50, 100];
    pageSizeper = 13;
    currentPage4 = 1;
    total = 0;
    pageCount = 0;
    pageSizeArrayd = [10, 13, 20, 30, 50, 100];
    pageSizeperd = 13;
    currentPage4d = 1;
    totald = 0;
    pageCountd = 0;
    updateTimeSecond=600000;//默认十分钟一次
    optionSelect = [];
    props = { multiple: true, value: "value", checkStrictly: false }; // 多级选择器配置多选
    options = []
    value = ''
    putRequest = {
        province: undefined,
        city: undefined,
        district: [],
        tenantName: undefined,
        skipCount: 0,
        maxResultCount: 10,
    }
    optionsA = [{
        value: 0,
        label: '未到校'
    }, {
        value: 1,
        label: '在校'
    }, {
        value: 2,
        label: '迟到'
    }, {
        value: 3,
        label: '请假'
    }]
    isTableLoading = false
    isTableLoadingd = false
    tableList = []
    tableListDetail = []
    tableListDetailBase = []
    staticItem = {}
    staticItemd = {}

    currentTime = this.getCurrentTime()
    private sickLeaveVisitSetting = new SickLeaveVisitSettingService();
    timer
    nowDay = moment().format('YYYY年MM月DD日')
    isDetails = false
    putRequestDetails = new PageSearchRequest()
    mounted() {
        // 当组件挂载到 DOM 上时，开始更新时间
        this.timer = setInterval(this.updateTime, 1000);
        this.requstTime();
    }
    beforeDestroy() {
        // 当组件从 DOM 上移除时，清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
    created() {
        this.getUserRegion();
    }
    goBack() {
        this.isDetails = false
    }
    goAll(){
        this.$router.back()
    }
    requiredStatus(type) {
        switch (type) {
            case 0: return "未到校";
            case 1: return "在校";
            case 2: return "迟到";
            case 3: return "请假"
        }
    }
    requstTime() {
        setInterval(() => {
            this.currentPage4++;
            if (this.currentPage4 > this.pageCount) {
                this.currentPage4 = 1;
            }
            this.getpage();
        }, this.updateTimeSecond);//十分钟一次自动刷新，
    }
    getpage() {
        console.log(this.currentPage4)
        if (this.optionSelect.length == 0) {
            this.$message.warning("请选择要查看的省市区");
            return;
        }
        this.putRequest.district = [];
        // this.isTableLoading = true
        this.optionSelect.forEach((e) => {
            this.putRequest.district.push(e[2]);
        })
        this.putRequest.maxResultCount = this.pageSizeper;
        this.putRequest.skipCount = (this.currentPage4 - 1) * this.pageSizeper;
        this.sickLeaveVisitSetting
            .getTenantDailyAttendanceInspectionReport(
                this.putRequest.province,
                this.putRequest.city,
                this.putRequest.district,
                this.putRequest.tenantName,
                this.putRequest.skipCount,
                this.putRequest.maxResultCount
            )
            .then((result) => {
                this.tableList = result.items;
                this.total = result.totalCount;
                if (this.total > 0) {
                    this.pageCount = Math.ceil(this.total / this.pageSizeper)
                }
                this.staticItem = result.staticItem
                this.isTableLoading = false;
            })
            .catch((err) => {
                this.$message.error('加载失败')
                this.isTableLoading = false;
            })
    }
    //获取可查看范围数据
    getUserRegion() {
        this.sickLeaveVisitSetting.getUserRegionLimit()
            .then((res) => {
                this.options = res;
                res.forEach((e) => {
                    e.children.forEach((two) => {
                        two.children.forEach((three) => {
                            this.optionSelect.push([e.value, two.value, three.value]);
                        })
                    })
                })
                console.log(this.optionSelect)
            })
            .finally(() => {
                this.getpage();
            })
    }


    private async logout() {
        await UserModule.LogOut();
        location.reload();
    }
    updateClock() {
        let time = ''
        setTimeout(() => {
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            time = `${hours}:${minutes}:${seconds}`
        }, 1000)
        return time
    }
    getCurrentTime() {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }
    updateTime() {
        this.currentTime = this.getCurrentTime();
    }
    goDetails(row) {
        this.isDetails = true
        this.putRequestDetails.tenantId = row.tenantId
        this.getpageDetails()
    }

    handleSizeChange(val) {

        this.pageSizeperd = val;
        this.currentPage4d = 1;
        this.getpageDetails();
        scrollTo(0, 800);
    }
    handleCurrentChange(val) {

        this.currentPage4d = val;
        this.getpageDetails();
        scrollTo(0, 800);
    }

    seach(){
      this.tableListDetail = [];
      this.isTableLoadingd = true;
      // this.currentPage4d = 1;
      // this.getpageDetails();
      if(this.putRequestDetails.attendanceSnapshotStatus <= 3 && this.putRequestDetails.name != undefined && this.putRequestDetails.name != ""){
        this.tableListDetail = this.tableListDetailBase.filter(x=>x.attendanceSnapshotStatus == this.putRequestDetails.attendanceSnapshotStatus && x.name.toLowerCase().includes(this.putRequestDetails.name.toLowerCase()))
      }else  if(this.putRequestDetails.attendanceSnapshotStatus <= 3 ){
        this.tableListDetail = this.tableListDetailBase.filter(x=>x.attendanceSnapshotStatus == this.putRequestDetails.attendanceSnapshotStatus)
      }else if(this.putRequestDetails.name != undefined && this.putRequestDetails.name != ""){
        this.tableListDetail = this.tableListDetailBase.filter(x=>x.name.toLowerCase().includes(this.putRequestDetails.name.toLowerCase()));
      }else {
        this.tableListDetail = this.tableListDetailBase;
      }
      this.isTableLoadingd = false;
    }
    getpageDetails(): void {
        this.isTableLoadingd = true;
        this.putRequestDetails.attendanceSnapshotStatus = undefined;
        this.putRequestDetails.maxResultCount = this.pageSizeperd;
        this.putRequestDetails.skipCount = (this.currentPage4d - 1) * this.pageSizeperd;
        this.sickLeaveVisitSetting
            .getDailyAttendanceInspectionReportSchool(
                this.putRequestDetails.tenantId,
                this.putRequestDetails.name,
                this.putRequestDetails.attendanceSnapshotStatus,
                this.putRequestDetails.skipCount,
                this.putRequestDetails.maxResultCount
            )
            .then((result) => {
                this.tableListDetail = result.items;
                this.tableListDetailBase = result.items;
                this.totald = result.totalCount
                this.staticItemd = result.staticItem
                this.isTableLoadingd = false;
                this.putRequestDetails.attendanceSnapshotStatus =99;
            })
            .catch((err) => {
                this.$message.error('加载失败')
                this.isTableLoadingd = false;
            })
    }
}

